<template>
    <v-dialog v-model="show" width="785px" persistent>
        <div class="modal" style="height: 218px">
            <v-row>
                <div class="icon-modal table-cell" style="height: 218px">
                    <v-layout class="delete-warning-icon">
                        <v-flex>
                            <img style="position: relative;top: -43px;" :src="require('@/assets/img/warning.svg')"
                                 alt=""/>
                        </v-flex>
                    </v-layout>
                </div>
                <v-col class="table-cell modal-content c-success">
                    <p class="c-p" style="top: 3px;">Company Information updated.<br>Please allow some time for the changes to take effect on your mobile devices.</p>

                    <div class="buttons d-flex">
                        <v-btn
                                class="btn-blanco c-blanco"
                                rounded
                                depressed
                                @click="close"
                                style="top: 20px;"
                                width="129"
                        >Ok
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-dialog>
</template>
<script>
    export default {
        props: ['show', 'hide'],
        components: {},
        methods: {
            close: function () {
                window.location.reload();
            }
        },
    };
</script>